<template>
	<loginBase class=""  
    element-loading-text="登录中,请稍后..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.2)" :minheight="showGeetest?'560px':'480px'">
		<div class="loginM" v-if="page!='qr'">
			<div @click="pageChangeFun('qr')" class="imgC"></div>
			<div class="imgT"></div>
			<div class="title">
				<span @click="tabChange('pwd')" :class="type=='code'?'':'title_active'">密码登录</span>
				<strong></strong>
				<span @click="tabChange('code')" :class="type=='code'?'title_active':''">验证码登录</span>
			</div>
			
			<el-form v-if="type=='code'" class="loginForm" :model="codePost" :hide-required-asterisk="true" :rules="codeRules" ref="codeForm" label-width="80px" label-position="top">
			  <el-form-item class="mobileNumer" label="手机号码" prop="mobile">
					<el-input placeholder="请输入手机号码" v-model="codePost.mobile">
					<template slot="prefix">
						<el-dropdown  @command="mobileNumFun" trigger="click">
							  <span class="mobileNumer_line" style="cursor: pointer;">
								<span style="width: 30px;display: inline-block; ">{{mobileNum}}</span> <i class="el-icon-caret-bottom"></i>
							  </span>
							  <el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="item.val" v-for="(item,index) in mobileNumList">{{item.name}} {{item.val}}</el-dropdown-item>
							  </el-dropdown-menu>
							</el-dropdown>
					</template>
					</el-input>
			  </el-form-item>
			  <el-form-item class="getcode" label="验证码" prop="code">
				<el-input v-model="codePost.code"  placeholder="请输入验证码">
					<template slot="suffix">
						<span @click="getCodeFun" class="getcode_num" :style="{'color':(codePost.mobile.length==11)?'#006aff':'#b6babf'}">{{codetitle}}</span>
					</template>
				</el-input>
			  </el-form-item>
			  <el-form-item v-if="showGeetest" class="getcode" label="智能验证">
					<div id="captcha"></div>
			  </el-form-item>
			  <el-form-item label="" style="margin-top: -10px;">
				<div class="page_to">
					<router-link to="/register">免费注册</router-link>
					<!-- <a href="">忘记密码</a> -->
				</div> 
			  </el-form-item>
			  <el-form-item style="position: absolute;bottom: 15px;width: 308px;">
				<el-button @click="sureLogin" type="primary" style="width: 100%;height: 50px;font-size: 16px;">{{!loginLoading?'登录':'登录中，请稍等'}}</el-button>
				<p class="agrement">登录即表示同意<router-link target="_blank" :to="{ 
					name: 'contract', 
					// params: { id: 123 },
					query: { type: 'service' }
				  }">《注册协议》</router-link>
				  <router-link target="_blank" :to="{ 
					name: 'contract', 
					// params: { id: 123 },
					query: { type: 'people' }
				  }">《个人信息处理规则》</router-link></p>
			  </el-form-item>
			</el-form>
			
			<el-form v-else class="loginForm" :model="codePost" :hide-required-asterisk="true" :rules="pwdRules" ref="pwdForm" label-width="80px" label-position="top">
			  <el-form-item label="手机号码" prop="mobile">
				<el-input @keyup.enter.native="sureLogin" v-model="codePost.mobile" placeholder="请输入手机号码"></el-input>
			  </el-form-item>
			  <el-form-item label="登录密码" prop="password">
				<el-input @keyup.enter.native="sureLogin" v-model="codePost.password" type="password" placeholder="请输入密码"></el-input>
			  </el-form-item>
			  <el-form-item v-if="showGeetest" class="getcode" label="智能验证">
					<div id="captcha1"></div>
			  </el-form-item>
			  <el-form-item label="" style="margin-top: -10px;">
				<div class="page_to">
					<router-link to="register">免费注册</router-link>
					<router-link to="forget">忘记密码</router-link>
				</div> 
			  </el-form-item>
			  <el-form-item style="position: absolute;bottom: 15px;width: 308px;">
				<el-button @keyup.enter.native="sureLogin" @click="sureLogin" type="primary" style="width: 100%;height: 50px;font-size: 16px;">{{!loginLoading?'登录':'登录中，请稍等'}}</el-button>
				<p class="agrement">登录即表示同意<router-link target="_blank" :to="{
					name: 'contract', 
					// params: { id: 123 },
					query: { type: 'service' }
				  }">《注册协议》</router-link>
				  <router-link target="_blank" :to="{ 
					name: 'contract', 
					// params: { id: 123 },
					query: { type: 'people' }
				  }">《个人信息处理规则》</router-link></p>
			  </el-form-item>
			</el-form>
		</div>
		
		<div v-else>
			<div @click="pageChangeFun('input')" class="imgCQ"></div>
			<div class="imgTQ"></div>
			<div class="title">
				<span class="title_active">微信扫码登录</span>
			</div>
			<div class="qr_box">
				<div class="qr_box_img"></div>
				<div class="qr_box_flex">
					<img src="../../../../admin/login/img/wxicon.png" alt="" srcset="" />
					微信扫一扫
				</div>
			</div>
			<p class="agrement" style="margin-top: 35px;">登录即表示同意<a href="">《注册协议》</a><a href="">《个人信息处理规则》</a></p>
		</div>
	</loginBase>
</template>

<script>
	import {
		eltips
	} from "@/util/util";
	import loginBase from "@/views/admin/login/components/base.vue";
	import {
		resetRouter
	} from "@/router/index.js";
	import store from "@/store/index.js";
	import router from "@/router/index.js";
	const ro = [{
			name: "概况",
			component: "apps/weishop/merchants/overview.vue",
			path: "/weishop/merchants/overview",
			icon: "",
			layout: "1",
			router_name: "merchantsoverview",
			vue_name: "",
			app_level: 0,
			plugin: null,
			is_plugin: 0,
			_child: [],
		},
		// {
		// 	name: "店铺",
		// 	component: "Layout",
		// 	path: "",
		// 	icon: "",
		// 	layout: "1",
		// 	router_name: "weishopstore",
		// 	vue_name: "",
		// 	app_level: 0,
		// 	plugin: null,
		// 	is_plugin: 0,
		// 	_child: [{
		// 			name: "店铺管理",
		// 			component: "apps/weishop/merchants/store/list.vue",
		// 			path: "/weishop/merchants/store/list",
		// 			icon: "https://mp.mocols.com/storage/upload/file/20250305/20250305183903945.svg",
		// 			layout: "1",
		// 			router_name: "merchantsstore",
		// 			vue_name: "",
		// 			app_level: 0,
		// 			plugin: null,
		// 			is_plugin: 0,
		// 			_child: [],
		// 		},
		// 		{
		// 			name: "店铺编辑",
		// 			component: "apps/weishop/merchants/store/page_add.vue",
		// 			path: "/weishop/merchants/store/page_add",
		// 			icon: "",
		// 			layout: "2",
		// 			router_name: "merchantsstore",
		// 			vue_name: "",
		// 			app_level: 0,
		// 			plugin: null,
		// 			is_plugin: 0,
		// 			_child: [],
		// 		},
		// 		{
		// 			name: "页面管理",
		// 			component: "apps/weishop/merchants/store/page.vue",
		// 			path: "/weishop/merchants/store/page",
		// 			icon: require("@/static/img/weishop/mange/commdiygroup.svg"),
		// 			layout: "1",
		// 			router_name: "merchantsstore",
		// 			vue_name: "",
		// 			app_level: 0,
		// 			plugin: null,
		// 			is_plugin: 0,
		// 			_child: [],
		// 		},
		// 		{
		// 			name: "模板列表",
		// 			component: "apps/weishop/merchants/store/page_copy.vue",
		// 			path: "/weishop/merchants/store/page_copy",
		// 			icon: "https://mp.mocols.com/storage/upload/file/20250305/20250305183903945.svg",
		// 			layout: "2",
		// 			router_name: "merchantsstore",
		// 			vue_name: "",
		// 			app_level: 0,
		// 			plugin: null,
		// 			is_plugin: 0,
		// 			_child: [],
		// 		}
		// 	],
		// },

		{
			name: "商品",
			component: "Layout",
			path: "",
			icon: "",
			layout: "1",
			router_name: "weishopcommidy",
			vue_name: "",
			app_level: 0,
			plugin: null,
			is_plugin: 0,
			_child: [{
					name: "商品管理",
					component: "apps/weishop/merchants/goods/list.vue",
					path: "/weishop/merchants/goods/list",
					icon: "https://mp.mocols.com/storage/upload/file/20250305/20250305183903945.svg",
					layout: "1",
					router_name: "merchantscommidy",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "商品编辑",
					component: "apps/weishop/merchants/goods/list_add.vue",
					path: "/weishop/merchants/goods/list_add",
					icon: "",
					layout: "2",
					router_name: "merchantscommidy",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "商品分组",
					component: "apps/weishop/merchants/goods/group/list.vue",
					path: "/weishop/merchants/goods/group/list",
					icon: require("@/static/img/weishop/mange/commdiygroup.svg"),
					layout: "1",
					router_name: "merchantscommidy",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "新增分组",
					component: "apps/weishop/merchants/goods/group/addEdit.vue",
					path: "/weishop/merchants/goods/group/addEdit",
					icon: require("@/static/img/weishop/mange/commdiygroup.svg"),
					layout: "2",
					router_name: "weishopcommidy",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "服务承诺",
					component: "apps/weishop/merchants/goods/service/list.vue",
					path: "/weishop/merchants/goods/service/list",
					icon: require("@/static/img/weishop/mange/service.svg"),
					layout: "1",
					router_name: "merchantscommidy",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				// {
				// 	"name": "商品标签",
				// 	"component": "apps/weishop/merchants/goods/tag/list.vue",
				// 	"path": "/weishop/merchants/goods/tag/list",
				// 	"icon": "https://mp.mocols.com/storage/upload/file/20250903/202509031021504322.svg",
				// 	"layout": "1",
				// 	"router_name": "merchantsgoods",
				// 	"vue_name": "",
				// 	"app_level": 0,
				// 	"plugin": null,
				// 	"is_plugin": 0,
				// 	"_child": []
				// },
				{
					"name": "商品品牌",
					"component": "apps/weishop/merchants/goods/brand/list.vue",
					"path": "/weishop/merchants/goods/brand/list",
					"icon": "https://mp.mocols.com/storage/upload/file/20250903/202509031035401899.svg",
					"layout": "1",
					"router_name": "merchantsgoods",
					"vue_name": "",
					"app_level": 0,
					"plugin": null,
					"is_plugin": 0,
					"_child": []
				},
				{
					"name": "商品标签的添加与编辑",
					"component": "apps/weishop/merchants/goods/tag/add_edit.vue",
					"path": "/weishop/merchants/goods/tag/add_edit",
					"icon": "",
					"layout": "2",
					"router_name": "merchantsgoods",
					"vue_name": "",
					"app_level": 0,
					"plugin": null,
					"is_plugin": 0,
					"_child": []
				},
				{
					"name": "商品品牌添加与编辑",
					"component": "apps/weishop/merchants/goods/brand/add_edit.vue",
					"path": "/weishop/merchants/goods/brand/add_edit",
					"icon": "",
					"layout": "2",
					"router_name": "merchantsgoods",
					"vue_name": "",
					"app_level": 0,
					"plugin": null,
					"is_plugin": 0,
					"_child": []
				}
			],
		},
		{
		    "id": 984,
		    "name": "订单",
		    "component": "Layout",
		    "path": "",
		    "icon": "",
		    "layout": "1",
		    "router_name": "weishoporder",
		    "vue_name": "",
		    "app_level": 0,
		    "plugin": null,
		    "is_plugin": 0,
		    "_child": [
		        {
		            "id": 985,
		            "name": "订单概况",
		            "component": "apps/weishop/merchants/order/overview.vue",
		            "path": "/weishop/merchants/order/overview",
		            "icon": "https://mp.mocols.com/storage/upload/file/20250309/202503091043558120.svg",
		            "layout": "1",
		            "router_name": "weishoporder",
		            "vue_name": "",
		            "app_level": 0,
		            "plugin": null,
		            "is_plugin": 0,
		            "_child": []
		        },
		        {
		            "id": 986,
		            "name": "订单管理",
		            "component": "apps/weishop/merchants/order/list.vue",
		            "path": "/weishop/merchants/order/list",
		            "icon": "https://mp.mocols.com/storage/upload/file/20250305/202503051844465742.svg",
		            "layout": "1",
		            "router_name": "weishoporder",
		            "vue_name": "",
		            "app_level": 0,
		            "plugin": null,
		            "is_plugin": 0,
		            "_child": []
		        },
		        {
		            "id": 987,
		            "name": "售后订单",
		            "component": "apps/weishop/merchants/order/refund.vue",
		            "path": "/weishop/merchants/order/refund",
		            "icon": "https://mp.mocols.com/storage/upload/file/20250308/202503081407329504.svg",
		            "layout": "1",
		            "router_name": "weishoporder",
		            "vue_name": "",
		            "app_level": 0,
		            "plugin": null,
		            "is_plugin": 0,
		            "_child": []
		        },
		        // {
		        //     "id": 988,
		        //     "name": "订单评论",
		        //     "component": "Layout",
		        //     "path": "",
		        //     "icon": "https://mp.mocols.com/storage/upload/file/20250305/20250305184240460.svg",
		        //     "layout": "1",
		        //     "router_name": "weishoporder",
		        //     "vue_name": "",
		        //     "app_level": 0,
		        //     "plugin": null,
		        //     "is_plugin": 0,
		        //     "_child": [
		        //         {
		        //             "id": 1121,
		        //             "name": "评论管理",
		        //             "component": "apps/weishop/order/comment/list.vue",
		        //             "path": "/weishop/order/comment/list",
		        //             "icon": "",
		        //             "layout": "1",
		        //             "router_name": "weishoporder",
		        //             "vue_name": "",
		        //             "app_level": 0,
		        //             "plugin": null,
		        //             "is_plugin": 0,
		        //             "_child": []
		        //         },
		        //         {
		        //             "id": 990,
		        //             "name": "评论设置",
		        //             "component": "apps/weishop/order/comment/set.vue",
		        //             "path": "/weishop/order/comment/set",
		        //             "icon": "",
		        //             "layout": "1",
		        //             "router_name": "weishoporder",
		        //             "vue_name": "",
		        //             "app_level": 0,
		        //             "plugin": null,
		        //             "is_plugin": 0,
		        //             "_child": []
		        //         }
		        //     ]
		        // },
		        {
		            "id": 1080,
		            "name": "发货管理",
		            "component": "apps/weishop/merchants/order/delivery.vue",
		            "path": "/weishop/merchants/order/delivery",
		            "icon": "https://mp.mocols.com/storage/upload/file/20250310/202503101324098689.svg",
		            "layout": "1",
		            "router_name": "weishoporder",
		            "vue_name": "",
		            "app_level": 0,
		            "plugin": null,
		            "is_plugin": 0,
		            "_child": []
		        },
		        {
		            "id": 1122,
		            "name": "订单导出",
		            "component": "apps/weishop/merchants/order/export.vue",
		            "path": "/weishop/merchants/order/export",
		            "icon": "https://mp.mocols.com/storage/upload/file/20250310/202503101334407350.svg",
		            "layout": "1",
		            "router_name": "weishoporder",
		            "vue_name": "",
		            "app_level": 0,
		            "plugin": null,
		            "is_plugin": 0,
		            "_child": []
		        },
		        {
		            "id": 1271,
		            "name": "订单详情",
		            "component": "apps/weishop/merchants/order/detail.vue",
		            "path": "/weishop/merchants/order/detail",
		            "icon": "",
		            "layout": "2",
		            "router_name": "weishoporder",
		            "vue_name": "",
		            "app_level": 0,
		            "plugin": null,
		            "is_plugin": 0,
		            "_child": []
		        },
		        {
		            "id": 1273,
		            "name": "售后详情",
		            "component": "apps/weishop/merchants/order/refund_detail.vue",
		            "path": "/weishop/merchants/order/refund_detail",
		            "icon": "",
		            "layout": "2",
		            "router_name": "weishoporder",
		            "vue_name": "",
		            "app_level": 0,
		            "plugin": null,
		            "is_plugin": 0,
		            "_child": []
		        }
		    ]
		},
		{
			name: "会员",
			component: "Layout",
			path: "",
			icon: "",
			layout: "1",
			router_name: "weishopmember",
			vue_name: "",
			app_level: 0,
			plugin: null,
			is_plugin: 0,
			_child: [{
					name: "会员概况",
					component: "apps/weishop/merchants/member/overview.vue",
					path: "/weishop/merchants/member/overview",
					icon: "https://mp.mocols.com/storage/upload/file/20250308/202503081614495711.svg",
					layout: "1",
					router_name: "weishopmember",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "会员管理",
					component: "apps/weishop/merchants/member/list.vue",
					path: "/weishop/merchants/member/list",
					icon: "https://mp.mocols.com/storage/upload/file/20250310/202503101413049290.svg",
					layout: "1",
					router_name: "weishopmember",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "会员详情",
					component: "apps/weishop/merchants/member/list_detail.vue",
					path: "/weishop/merchants/member/list_detail",
					icon: "https://mp.mocols.com/storage/upload/file/20240520/202405201843405102.svg",
					layout: "2",
					router_name: "weishopmember",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
				    "name": "会员标签",
				    "component": "apps/weishop/merchants/member/tag.vue",
				    "path": "/weishop/merchants/member/tag",
				    "icon": "https://mp.mocols.com/storage/upload/file/20250310/202503101306037422.svg",
				    "layout": "1",
				    "router_name": "weishopmember",
				    "vue_name": "",
				    "app_level": 0,
				    "plugin": null,
				    "is_plugin": 0,
				    "_child": []
				}
			],
		},
		{
			name: "数据",
			component: "Layout",
			path: "",
			icon: "",
			layout: "1",
			router_name: "weishopdata",
			vue_name: "",
			app_level: 0,
			plugin: null,
			is_plugin: 0,
			_child: [
				{
					name: "交易概况",
					component: "apps/weishop/merchants/record/overview.vue",
					path: "/weishop/record/member/overview",
					icon: "https://mp.mocols.com/storage/upload/file/20250308/202503081614495711.svg",
					layout: "1",
					router_name: "weishopdata",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "商品排行",
					component: "apps/weishop/merchants/record/good_pai.vue",
					path: "/weishop/merchants/record/good_pai",
					icon: "https://mp.mocols.com/storage/upload/file/20250305/20250305185017868.svg",
					layout: "1",
					router_name: "weishopdata",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				}
			],
		},
		// {
		// 	name: "数据",
		// 	component: "Layout",
		// 	path: "",
		// 	icon: "",
		// 	layout: "1",
		// 	router_name: "weishopdata",
		// 	vue_name: "",
		// 	app_level: 0,
		// 	plugin: null,
		// 	is_plugin: 0,
		// 	_child: [{
		// 			name: "门店数据",
		// 			component: "apps/weishop/shop/record/data.vue",
		// 			path: "/weishop/shop/record/data",
		// 			icon: "https://mp.mocols.com/storage/upload/file/20250307/202503072155319813.svg",
		// 			layout: "1",
		// 			router_name: "weishopdata",
		// 			vue_name: "",
		// 			app_level: 0,
		// 			plugin: null,
		// 			is_plugin: 0,
		// 			_child: [],
		// 		},
		// 		{
		// 			name: "门店数据详情",
		// 			component: "apps/weishop/shop/record/data_detail.vue",
		// 			path: "/weishop/shop/record/data_detail",
		// 			icon: "https://mp.mocols.com/storage/upload/file/20240520/202405201843405102.svg",
		// 			layout: "2",
		// 			router_name: "weishopdata",
		// 			vue_name: "",
		// 			app_level: 0,
		// 			plugin: null,
		// 			is_plugin: 0,
		// 			_child: [],
		// 		},
		// 		{
		// 			name: "核销数据",
		// 			component: "apps/weishop/shop/record/writeOff.vue",
		// 			path: "/weishop/shop/record/writeOff",
		// 			icon: require("@/static/img/weishop/mange/distro.svg"),
		// 			layout: "1",
		// 			router_name: "weishopdata",
		// 			vue_name: "",
		// 			app_level: 0,
		// 			plugin: null,
		// 			is_plugin: 0,
		// 			_child: [],
		// 		},
		// 	],
		// },
		// {
		//     "id": 999,
		//     "name": "营销",
		//     "component": "apps/weishop/shop/market/index.vue",
		//     "path": "/weishop/shop/market/index",
		//     "icon": "",
		//     "layout": "1",
		//     "router_name": "weishopmarket",
		//     "vue_name": "",
		//     "app_level": 0,
		//     "plugin": null,
		//     "is_plugin": 1,
		//     "_child": [
		//         {
		//             "id": 1154,
		//             "name": "礼券",
		//             "component": "2",
		//             "path": "1",
		//             "icon": "",
		//             "layout": "1",
		//             "router_name": "2",
		//             "vue_name": "",
		//             "app_level": 1,
		//             "plugin": {
		//                 "id": 26,
		//                 "title": "礼券",
		//                 "description": "锁定有效流量，促进店铺转化。",
		//                 "image": "88725",
		//                 "cat_id": 2,
		//                 "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638128673.png",
		//                 "cat": {
		//                     "id": 2,
		//                     "title": "营销应用"
		//                 }
		//             },
		//             "is_plugin": 0,
		//             "_child": [
		//                 {
		//                     "id": 1231,
		//                     "name": "礼券管理",
		//                     "component": "apps/weishop/shop/application/gift/list.vue",
		//                     "path": "/weishop/shop/application/gift/list",
		//                     "icon": "https://mp.mocols.com/storage/upload/file/20250309/2025030910532069.svg",
		//                     "layout": "1",
		//                     "router_name": "weishopmarket",
		//                     "vue_name": "",
		//                     "app_level": 0,
		//                     "plugin": {
		//                         "id": 26,
		//                         "title": "礼券",
		//                         "description": "锁定有效流量，促进店铺转化。",
		//                         "image": "88725",
		//                         "cat_id": 2,
		//                         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638128673.png",
		//                         "cat": {
		//                             "id": 2,
		//                             "title": "营销应用"
		//                         }
		//                     },
		//                     "is_plugin": 0,
		//                     "_child": []
		//                 },
		//                 {
		//                     "id": 1232,
		//                     "name": "领取记录",
		//                     "component": "apps/weishop/shop/application/gift/receive.vue",
		//                     "path": "/weishop/shop/application/gift/receive",
		//                     "icon": "https://mp.mocols.com/storage/upload/file/20250310/202503100912055471.svg",
		//                     "layout": "1",
		//                     "router_name": "weishopmarket",
		//                     "vue_name": "",
		//                     "app_level": 0,
		//                     "plugin": {
		//                         "id": 26,
		//                         "title": "礼券",
		//                         "description": "锁定有效流量，促进店铺转化。",
		//                         "image": "88725",
		//                         "cat_id": 2,
		//                         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638128673.png",
		//                         "cat": {
		//                             "id": 2,
		//                             "title": "营销应用"
		//                         }
		//                     },
		//                     "is_plugin": 0,
		//                     "_child": []
		//                 },
		//                 {
		//                     "id": 1236,
		//                     "name": "创建礼券",
		//                     "component": "apps/weishop/shop/application/gift/addEdit.vue",
		//                     "path": "/weishop/shop/application/gift/addEdit",
		//                     "icon": "",
		//                     "layout": "2",
		//                     "router_name": "weishopmarket",
		//                     "vue_name": "",
		//                     "app_level": 0,
		//                     "plugin": {
		//                         "id": 26,
		//                         "title": "礼券",
		//                         "description": "锁定有效流量，促进店铺转化。",
		//                         "image": "88725",
		//                         "cat_id": 2,
		//                         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638128673.png",
		//                         "cat": {
		//                             "id": 2,
		//                             "title": "营销应用"
		//                         }
		//                     },
		//                     "is_plugin": 0,
		//                     "_child": []
		//                 }
		//             ]
		//         },
		//         {
		//             "id": 1841,
		//             "name": "新客有礼",
		//             "component": "Layout",
		//             "path": "",
		//             "icon": "",
		//             "layout": "1",
		//             "router_name": "weishopmarket",
		//             "vue_name": "",
		//             "app_level": 1,
		//             "plugin": {
		//                 "id": 62,
		//                 "title": "新客有礼",
		//                 "description": "高效拉新，新人注册可获得奖励",
		//                 "image": "88726",
		//                 "cat_id": 1,
		//                 "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638128336.png",
		//                 "cat": {
		//                     "id": 1,
		//                     "title": "业务助手"
		//                 }
		//             },
		//             "is_plugin": 0,
		//             "_child": [
		//                 {
		//                     "id": 1860,
		//                     "name": "活动概况",
		//                     "component": "apps/weishop/shop/application/newcustomer/overview.vue",
		//                     "path": "/weishop/shop/application/newcustomer/overview",
		//                     "icon": "https://mp.mocols.com/storage/upload/file/20250309/202503091043558120.svg",
		//                     "layout": "1",
		//                     "router_name": "weishopmarket",
		//                     "vue_name": "",
		//                     "app_level": 0,
		//                     "plugin": {
		//                         "id": 62,
		//                         "title": "新客有礼",
		//                         "description": "高效拉新，新人注册可获得奖励",
		//                         "image": "88726",
		//                         "cat_id": 1,
		//                         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638128336.png",
		//                         "cat": {
		//                             "id": 1,
		//                             "title": "业务助手"
		//                         }
		//                     },
		//                     "is_plugin": 0,
		//                     "_child": []
		//                 },
		//                 {
		//                     "id": 1854,
		//                     "name": "活动管理",
		//                     "component": "apps/weishop/shop/application/newcustomer/list.vue",
		//                     "path": "/weishop/shop/application/newcustomer/list",
		//                     "icon": "https://mp.mocols.com/storage/upload/file/20250816/202508161311331741.svg",
		//                     "layout": "1",
		//                     "router_name": "weishopmarket",
		//                     "vue_name": "",
		//                     "app_level": 0,
		//                     "plugin": {
		//                         "id": 62,
		//                         "title": "新客有礼",
		//                         "description": "高效拉新，新人注册可获得奖励",
		//                         "image": "88726",
		//                         "cat_id": 1,
		//                         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638128336.png",
		//                         "cat": {
		//                             "id": 1,
		//                             "title": "业务助手"
		//                         }
		//                     },
		//                     "is_plugin": 0,
		//                     "_child": []
		//                 },
		//                 {
		//                     "id": 1855,
		//                     "name": "活动添加",
		//                     "component": "apps/weishop/shop/application/newcustomer/list_add.vue",
		//                     "path": "/weishop/shop/application/newcustomer/list_add",
		//                     "icon": "",
		//                     "layout": "2",
		//                     "router_name": "weishopmarket",
		//                     "vue_name": "",
		//                     "app_level": 0,
		//                     "plugin": {
		//                         "id": 62,
		//                         "title": "新客有礼",
		//                         "description": "高效拉新，新人注册可获得奖励",
		//                         "image": "88726",
		//                         "cat_id": 1,
		//                         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638128336.png",
		//                         "cat": {
		//                             "id": 1,
		//                             "title": "业务助手"
		//                         }
		//                     },
		//                     "is_plugin": 0,
		//                     "_child": []
		//                 }
		//             ]
		//         },
		//         {
		//             "id": 1844,
		//             "name": "单品折扣",
		//             "component": "1",
		//             "path": "1",
		//             "icon": "",
		//             "layout": "1",
		//             "router_name": "1",
		//             "vue_name": "",
		//             "app_level": 1,
		//             "plugin": {
		//                 "id": 65,
		//                 "title": "单品折扣",
		//                 "description": "店铺促销利器，快速提高商品销量",
		//                 "image": "88727",
		//                 "cat_id": 1,
		//                 "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638125362.png",
		//                 "cat": {
		//                     "id": 1,
		//                     "title": "业务助手"
		//                 }
		//             },
		//             "is_plugin": 0,
		//             "_child": [
		//                 {
		//                     "id": 1857,
		//                     "name": "活动概况",
		//                     "component": "apps/weishop/shop/application/seckill/dan_overview.vue",
		//                     "path": "/weishop/shop/application/seckill/dan_overview",
		//                     "icon": "https://mp.mocols.com/storage/upload/file/20250305/202503052118406958.svg",
		//                     "layout": "1",
		//                     "router_name": "weishopmarket",
		//                     "vue_name": "",
		//                     "app_level": 0,
		//                     "plugin": {
		//                         "id": 65,
		//                         "title": "单品折扣",
		//                         "description": "店铺促销利器，快速提高商品销量",
		//                         "image": "88727",
		//                         "cat_id": 1,
		//                         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638125362.png",
		//                         "cat": {
		//                             "id": 1,
		//                             "title": "业务助手"
		//                         }
		//                     },
		//                     "is_plugin": 0,
		//                     "_child": []
		//                 },
		//                 {
		//                     "id": 1852,
		//                     "name": "活动管理",
		//                     "component": "apps/weishop/shop/application/seckill/dan.vue",
		//                     "path": "/weishop/shop/application/seckill/dan",
		//                     "icon": "https://mp.mocols.com/storage/upload/file/20250816/202508161311331741.svg",
		//                     "layout": "1",
		//                     "router_name": "weishopmarket",
		//                     "vue_name": "",
		//                     "app_level": 0,
		//                     "plugin": {
		//                         "id": 65,
		//                         "title": "单品折扣",
		//                         "description": "店铺促销利器，快速提高商品销量",
		//                         "image": "88727",
		//                         "cat_id": 1,
		//                         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638125362.png",
		//                         "cat": {
		//                             "id": 1,
		//                             "title": "业务助手"
		//                         }
		//                     },
		//                     "is_plugin": 0,
		//                     "_child": []
		//                 },
		//                 {
		//                     "id": 1853,
		//                     "name": "新增活动",
		//                     "component": "apps/weishop/shop/application/seckill/dan_add.vue",
		//                     "path": "/weishop/shop/application/seckill/dan_add",
		//                     "icon": "",
		//                     "layout": "2",
		//                     "router_name": "weishopmarket",
		//                     "vue_name": "",
		//                     "app_level": 0,
		//                     "plugin": {
		//                         "id": 65,
		//                         "title": "单品折扣",
		//                         "description": "店铺促销利器，快速提高商品销量",
		//                         "image": "88727",
		//                         "cat_id": 1,
		//                         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638125362.png",
		//                         "cat": {
		//                             "id": 1,
		//                             "title": "业务助手"
		//                         }
		//                     },
		//                     "is_plugin": 0,
		//                     "_child": []
		//                 }
		//             ]
		//         },
		//         {
		//             "id": 1229,
		//             "name": "秒杀",
		//             "component": "1",
		//             "path": "",
		//             "icon": "",
		//             "layout": "1",
		//             "router_name": "1",
		//             "vue_name": "",
		//             "app_level": 1,
		//             "plugin": {
		//                 "id": 39,
		//                 "title": "限时秒杀",
		//                 "description": "快速抢购引导会员更多消费，低价、限购，吸引更多会员。",
		//                 "image": "88729",
		//                 "cat_id": 2,
		//                 "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638122115.png",
		//                 "cat": {
		//                     "id": 2,
		//                     "title": "营销应用"
		//                 }
		//             },
		//             "is_plugin": 0,
		//             "_child": [
		//                 {
		//                     "id": 1858,
		//                     "name": "活动概况",
		//                     "component": "apps/weishop/shop/application/seckill/activity_overview.vue",
		//                     "path": "/weishop/shop/application/seckill/activity_overview",
		//                     "icon": "https://mp.mocols.com/storage/upload/file/20250309/202503091043558120.svg",
		//                     "layout": "1",
		//                     "router_name": "weishopmarket",
		//                     "vue_name": "",
		//                     "app_level": 0,
		//                     "plugin": {
		//                         "id": 39,
		//                         "title": "限时秒杀",
		//                         "description": "快速抢购引导会员更多消费，低价、限购，吸引更多会员。",
		//                         "image": "88729",
		//                         "cat_id": 2,
		//                         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638122115.png",
		//                         "cat": {
		//                             "id": 2,
		//                             "title": "营销应用"
		//                         }
		//                     },
		//                     "is_plugin": 0,
		//                     "_child": []
		//                 },
		//                 {
		//                     "id": 1230,
		//                     "name": "活动管理",
		//                     "component": "apps/weishop/shop/application/seckill/activity.vue",
		//                     "path": "/weishop/shop/application/seckill/activity",
		//                     "icon": "https://mp.mocols.com/storage/upload/file/20250816/202508161311331741.svg",
		//                     "layout": "1",
		//                     "router_name": "weishopmarket",
		//                     "vue_name": "",
		//                     "app_level": 0,
		//                     "plugin": {
		//                         "id": 39,
		//                         "title": "限时秒杀",
		//                         "description": "快速抢购引导会员更多消费，低价、限购，吸引更多会员。",
		//                         "image": "88729",
		//                         "cat_id": 2,
		//                         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638122115.png",
		//                         "cat": {
		//                             "id": 2,
		//                             "title": "营销应用"
		//                         }
		//                     },
		//                     "is_plugin": 0,
		//                     "_child": []
		//                 },
		//                 {
		//                     "id": 1845,
		//                     "name": "新增活动",
		//                     "component": "apps/weishop/shop/application/seckill/activity_add.vue",
		//                     "path": "/weishop/shop/application/seckill/activity_add",
		//                     "icon": "",
		//                     "layout": "2",
		//                     "router_name": "weishopmarket",
		//                     "vue_name": "",
		//                     "app_level": 0,
		//                     "plugin": {
		//                         "id": 39,
		//                         "title": "限时秒杀",
		//                         "description": "快速抢购引导会员更多消费，低价、限购，吸引更多会员。",
		//                         "image": "88729",
		//                         "cat_id": 2,
		//                         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141638122115.png",
		//                         "cat": {
		//                             "id": 2,
		//                             "title": "营销应用"
		//                         }
		//                     },
		//                     "is_plugin": 0,
		//                     "_child": []
		//                 }
		//             ]
		//         },
		// 		{
		// 		    "id": 1163,
		// 		    "name": "满额包邮",
		// 		    "component": "2",
		// 		    "path": "1",
		// 		    "icon": "",
		// 		    "layout": "1",
		// 		    "router_name": "2",
		// 		    "vue_name": "",
		// 		    "app_level": 1,
		// 		    "plugin": {
		// 		        "id": 28,
		// 		        "title": "满额活动",
		// 		        "description": "满减满邮，提升客单促消费",
		// 		        "image": "88738",
		// 		        "cat_id": 2,
		// 		        "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141719169249.png",
		// 		        "cat": {
		// 		            "id": 2,
		// 		            "title": "营销应用"
		// 		        }
		// 		    },
		// 		    "is_plugin": 0,
		// 		    "_child": [
		// 		        // {
		// 		        //     "id": 1234,
		// 		        //     "name": "满额包邮",
		// 		        //     "component": "apps/weishop/shop/application/mail/set.vue",
		// 		        //     "path": "/weishop/shop/application/mail/set",
		// 		        //     "icon": "https://mp.mocols.com/storage/upload/file/20250816/202508161553354981.svg",
		// 		        //     "layout": "1",
		// 		        //     "router_name": "weishopmarket",
		// 		        //     "vue_name": "",
		// 		        //     "app_level": 0,
		// 		        //     "plugin": {
		// 		        //         "id": 28,
		// 		        //         "title": "满额活动",
		// 		        //         "description": "满减满邮，提升客单促消费",
		// 		        //         "image": "88738",
		// 		        //         "cat_id": 2,
		// 		        //         "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141719169249.png",
		// 		        //         "cat": {
		// 		        //             "id": 2,
		// 		        //             "title": "营销应用"
		// 		        //         }
		// 		        //     },
		// 		        //     "is_plugin": 0,
		// 		        //     "_child": []
		// 		        // },
		// 		        {
		// 		            "id": 1856,
		// 		            "name": "满额立减",
		// 		            "component": "apps/weishop/shop/application/mail/jian.vue",
		// 		            "path": "/weishop/shop/application/mail/jian",
		// 		            "icon": "https://mp.mocols.com/storage/upload/file/20250816/202508161553413076.svg",
		// 		            "layout": "1",
		// 		            "router_name": "weishopmarket",
		// 		            "vue_name": "",
		// 		            "app_level": 0,
		// 		            "plugin": {
		// 		                "id": 28,
		// 		                "title": "满额活动",
		// 		                "description": "满减满邮，提升客单促消费",
		// 		                "image": "88738",
		// 		                "cat_id": 2,
		// 		                "image_url": "https://qiniuyun.mocols.com/upload/images/20250814/202508141719169249.png",
		// 		                "cat": {
		// 		                    "id": 2,
		// 		                    "title": "营销应用"
		// 		                }
		// 		            },
		// 		            "is_plugin": 0,
		// 		            "_child": []
		// 		        }
		// 		    ]
		// 		}
		//     ]
		// },
		{
			app_level: 0,
			icon: "",
			id: "",
			is_plugin: 1,
			layout: "1",
			name: "应用",
			component: "apps/weishop/merchants/application/index.vue",
			path: "/weishop/merchants/application/index",
			plugin: null,
			router_name: "weishopapplication",
			vue_name: "",
			_child: [
				{
					id: 12,
					name: "云打印机",
					component: "2",
					path: "",
					icon: "",
					layout: "1",
					router_name: "weishopapplication",
					vue_name: "",
					app_level: 1,
					plugin: {
						cat: {
							id: 3,
							title: "辅助工具",
						},
						cat_id: 3,
						description: "设置小票模板、打印销售小票。",
						id: 14,
						image_url: "https://qiniuyun.mocols.com/upload/images/20250815/20250815111312575.png",
						image: "19277",
						title: "云打印机",
					},
					is_plugin: 0,
					_child: [{
							id: 121,

							name: "云打印机",
							component: "apps/weishop/merchants/application/print/device.vue",
							path: "/weishop/merchants/application/print/device",
							icon: "https://mp.mocols.com/storage/upload/file/20250307/202503071735535395.svg",
							layout: "1",
							router_name: "weishopapplication",
							vue_name: "",
							app_level: 0,
							plugin: null,
							is_plugin: 0,
							_child: [],
						},
						{
							id: 122,

							name: "打印设置",
							component: "apps/weishop/merchants/application/print/set.vue",
							path: "/weishop/merchants/application/print/set",
							icon: "https://mp.mocols.com/storage/upload/file/20250308/202503081459456620.svg",
							layout: "1",
							router_name: "weishopapplication",
							vue_name: "",
							app_level: 0,
							plugin: null,
							is_plugin: 0,
							_child: [],
						},
					],
				}
			],
		},
		// {
		// 	name: "提现",
		// 	component: "apps/weishop/merchants/settlement/list.vue",
		// 	path: "/weishop/merchants/settlement/list",
		// 	icon: "https://mp.mocols.com/storage/upload/file/20250309/202503091043558120.svg",
		// 	layout: "1",
		// 	router_name: "merchantssettlement",
		// 	vue_name: "",
		// 	app_level: 0,
		// 	plugin: null,
		// 	is_plugin: 0,
		// 	_child: [],
		// },
		// {
		// 	name: "结算",
		// 	component: "Layout",
		// 	path: "",
		// 	icon: "",
		// 	layout: "1",
		// 	router_name: "weishopsettlement",
		// 	vue_name: "",
		// 	app_level: 0,
		// 	plugin: null,
		// 	is_plugin: 0,
		// 	_child: [
		// 		{
		// 			name: "结算概况",
		// 			component: "apps/weishop/merchants/settlement/overview.vue",
		// 			path: "/weishop/merchants/settlement/overview",
		// 			icon: "https://mp.mocols.com/storage/upload/file/20250309/202503091043558120.svg",
		// 			layout: "1",
		// 			router_name: "weishopsettlement",
		// 			vue_name: "",
		// 			app_level: 0,
		// 			plugin: null,
		// 			is_plugin: 0,
		// 			_child: [],
		// 		},
		// 		{
		// 			name: "结算管理",
		// 			component: "apps/weishop/merchants/settlement/list.vue",
		// 			path: "/weishop/merchants/settlement/list",
		// 			icon: "https://mp.mocols.com/storage/upload/file/20250309/202503091043558120.svg",
		// 			layout: "1",
		// 			router_name: "weishopsettlement",
		// 			vue_name: "",
		// 			app_level: 0,
		// 			plugin: null,
		// 			is_plugin: 0,
		// 			_child: [],
		// 		},
		// 	],
		// },
		{
			name: "押金",
			component: "Layout",
			path: "",
			icon: "",
			layout: "1",
			router_name: "weishopdeposit",
			vue_name: "",
			app_level: 0,
			plugin: null,
			is_plugin: 0,
			_child: [{
					name: "缴纳押金",
					component: "apps/weishop/merchants/deposit/list.vue",
					path: "/weishop/merchants/deposit/list",
					icon: "https://mp.mocols.com/storage/upload/file/20250309/202503091043558120.svg",
					layout: "1",
					router_name: "weishopdeposit",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "退押记录",
					component: "apps/weishop/merchants/deposit/tui.vue",
					path: "/weishop/merchants/deposit/tui",
					icon: "https://mp.mocols.com/storage/upload/file/20250309/202503091043558120.svg",
					layout: "1",
					router_name: "weishopdeposit",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
			],
		},
		{
			name: "财务",
			component: "Layout",
			path: "",
			icon: "",
			layout: "1",
			router_name: "weishopfinance",
			vue_name: "",
			app_level: 0,
			plugin: null,
			is_plugin: 0,
			_child: [{
					name: "财务概况",
					component: "apps/weishop/merchants/finance/overview.vue",
					path: "/weishop/merchants/finance/overview",
					icon: "https://mp.mocols.com/storage/upload/file/20250309/202503091043558120.svg",
					layout: "1",
					router_name: "weishopfinance",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				// {
				// 		name: "申请结算",
				// 		component: "apps/weishop/merchants/finance/jiesuan.vue",
				// 		path: "/weishop/merchants/finance/jiesuan",
				// 		icon: "https://mp.mocols.com/storage/upload/file/20250309/202503091043558120.svg",
				// 		layout: "2",
				// 		router_name: "weishopfinance",
				// 		vue_name: "",
				// 		app_level: 0,
				// 		plugin: null,
				// 		is_plugin: 0,
				// 		_child: [],
				// 	},
				{
						name: "申请结算",
						component: "apps/weishop/merchants/finance/comapplyfor.vue",
						path: "/weishop/merchants/finance/comapplyfor",
						icon: "https://mp.mocols.com/storage/upload/file/20250309/202503091043558120.svg",
						layout: "2",
						router_name: "weishopfinance",
						vue_name: "",
						app_level: 0,
						plugin: null,
						is_plugin: 0,
						_child: [],
					},
				{
					name: "申请结算",
					component: "apps/weishop/merchants/finance/applyfor.vue",
					path: "/weishop/merchants/finance/applyfor",
					icon: "https://mp.mocols.com/storage/upload/file/20240520/202405201843405102.svg",
					layout: "2",
					router_name: "weishopfinance",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "完成订单",
					component: "apps/weishop/merchants/finance/order.vue",
					path: "/weishop/merchants/finance/order",
					icon: "https://mp.mocols.com/common/storesvg/order.svg",
					layout: "1",
					router_name: "weishopfinance",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "结算管理",
					component: "apps/weishop/merchants/finance/withdrawal.vue",
					path: "/weishop/merchants/finance/withdrawal",
					icon: "https://mp.mocols.com/common/storesvg/ticheng.svg",
					layout: "1",
					router_name: "weishopfinance",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "账户管理",
					component: "apps/weishop/merchants/finance/account.vue",
					path: "/weishop/merchants/finance/account",
					icon: "https://mp.mocols.com/common/storesvg/tong.svg",
					layout: "1",
					router_name: "weishopfinance",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "账户添加",
					component: "apps/weishop/merchants/finance/account_add.vue",
					path: "/weishop/merchants/finance/account_add",
					icon: "https://mp.mocols.com/common/storesvg/zhanghu.svg",
					layout: "2",
					router_name: "weishopfinance",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				}
			],
		},
		{
			name: "设置",
			component: "Layout",
			path: "",
			icon: "https://mp.mocols.com/storage/upload/file/20250308/202503081459456620.svg",
			layout: "1",
			router_name: "weishopsetting",
			vue_name: "",
			app_level: 0,
			plugin: null,
			is_plugin: 0,
			_child: [
				// {
				// 	name: "商户信息",
				// 	component: "apps/weishop/merchants/setting/set.vue",
				// 	path: "/weishop/merchants/setting/set",
				// 	icon: 'https://mp.mocols.com/storage/upload/file/20250305/202503051830415320.svg',
				// 	layout: "1",
				// 	router_name: "weishopsetting",
				// 	vue_name: "",
				// 	app_level: 0,
				// 	plugin: null,
				// 	is_plugin: 0,
				// 	_child: [],
				// },
				{
				    "name": "商户设置",
				    "component": "Layout",
				    "path": "",
				    "icon": "https://mp.mocols.com/storage/upload/file/20250305/202503051830415320.svg",
				    "layout": "1",
				    "router_name": "weishopsetting",
				    "vue_name": "",
				    "app_level": 0,
				    "plugin": null,
				    "is_plugin": 0,
				    "_child": [
				        {
				            "name": "商户信息",
				            "component": "apps/weishop/merchants/setting/set.vue",
				            "path": "/weishop/merchants/setting/set",
				            "icon": "",
				            "layout": "1",
				            "router_name": "weishopsetting",
				            "vue_name": "",
				            "app_level": 0,
				            "plugin": null,
				            "is_plugin": 0,
				            "_child": []
				        },
				        {
				            "name": "地址设置",
				            "component": "apps/weishop/merchants/setting/set_address.vue",
				            "path": "/weishop/merchants/setting/set_address",
				            "icon": "",
				            "layout": "1",
				            "router_name": "weishopsetting",
				            "vue_name": "",
				            "app_level": 0,
				            "plugin": null,
				            "is_plugin": 0,
				            "_child": []
				        },
						{
						    "name": "其他设置",
						    "component": "apps/weishop/merchants/setting/set_other.vue",
						    "path": "/weishop/merchants/setting/set_other",
						    "icon": "",
						    "layout": "1",
						    "router_name": "weishopsetting",
						    "vue_name": "",
						    "app_level": 0,
						    "plugin": null,
						    "is_plugin": 0,
						    "_child": []
						}
				    ]
				},
				{
					name: "运费模板",
					component: "apps/weishop/merchants/setting/delivery/template/index.vue",
					path: "/weishop/merchants/setting/delivery/template/index",
					icon: 'https://mp.mocols.com/storage/upload/file/20250310/202503101334524251.svg',
					layout: "1",
					router_name: "weishopsetting",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "添加运费模板",
					component: "apps/weishop/merchants/setting/delivery/template/template_add.vue",
					path: "/weishop/merchants/setting/delivery/template/template_add",
					icon: 'https://mp.mocols.com/storage/upload/file/20250310/202503101334524251.svg',
					layout: "2",
					router_name: "weishopsetting",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				{
					name: "地址管理",
					component: "apps/weishop/merchants/setting/address.vue",
					path: "/weishop/merchants/setting/address",
					icon: 'https://mp.mocols.com/storage/upload/file/20250305/202503052215566969.svg',
					layout: "1",
					router_name: "weishopsetting",
					vue_name: "",
					app_level: 0,
					plugin: null,
					is_plugin: 0,
					_child: [],
				},
				// {
				// 	name: "支付设置",
				// 	component: "Layout",
				// 	path: "",
				// 	icon: "https://mp.mocols.com/storage/upload/file/20250310/202503101351307381.svg",
				// 	layout: "1",
				// 	router_name: "weishopsetting",
				// 	vue_name: "",
				// 	app_level: 0,
				// 	plugin: null,
				// 	is_plugin: 0,
				// 	_child: [{
				// 			name: "支付设置",
				// 			component: "apps/weishop/shop/setting/pay/set.vue",
				// 			path: "/weishop/shop/setting/pay/set",
				// 			icon: "https://mp.mocols.com/storage/upload/file/20240520/202405201843405102.svg",
				// 			layout: "1",
				// 			router_name: "weishopsetting",
				// 			vue_name: "",
				// 			app_level: 0,
				// 			plugin: null,
				// 			is_plugin: 0,
				// 			_child: [],
				// 		},
				// 		{
				// 			name: "支付模板",
				// 			component: "apps/weishop/shop/setting/pay/template.vue",
				// 			path: "/weishop/shop/setting/pay/template",
				// 			icon: "https://mp.mocols.com/storage/upload/file/20240520/202405201843405102.svg",
				// 			layout: "1",
				// 			router_name: "weishopsetting",
				// 			vue_name: "",
				// 			app_level: 0,
				// 			plugin: null,
				// 			is_plugin: 0,
				// 			_child: [],
				// 		},
				// 		{
				// 			name: "新增支付模板",
				// 			component: "apps/weishop/shop/setting/pay/template_add.vue",
				// 			path: "/weishop/shop/setting/pay/template_add",
				// 			icon: "https://mp.mocols.com/storage/upload/file/20240520/202405201843405102.svg",
				// 			layout: "2",
				// 			router_name: "weishopsetting",
				// 			vue_name: "",
				// 			app_level: 0,
				// 			plugin: null,
				// 			is_plugin: 0,
				// 			_child: [],
				// 		},
				// 	],
				// },
			],
		},
	];
	export default {
		components: {
			loginBase
		},
		name: "adminlogin",
		data() {
			return {
				page: "input",
				type: "pwd",
				mobileNum: "+86",
				mobileNumList: [{
						name: "中国大陆",
						val: "+86"
					},
					{
						name: "中国香港",
						val: "+852"
					},
				],

				codeInter: null,
				codeTime: 60,
				codetitle: "获取验证码",
				codePost: {
					mobile:'',
					account: "",
					code: "",
					password: "",
					captcha_output: "",
					lot_number: "",
					pass_token: "",
					gen_time: "",
					sms_code:""
				},

				codeRules: {
					mobile: [{
						required: true,
						message: "请输入手机号码",
						trigger: "blur"
					}, ],
					code: [{
						required: true,
						message: "请输入验证码",
						trigger: "blur"
					}],
				},

				pwdPost: {
					account: "",
					password: "",
				},
				pwdRules: {
					account: [{
						required: true,
						message: "请输入手机号码",
						trigger: "blur"
					}, ],
					password: [{
						required: true,
						message: "请输入密码",
						trigger: "blur"
					}],
				},
				configData: {},
				showGeetest: false,
				loginLoading: false,
			};
		},
		created() {
			sessionStorage.setItem("shopid",this.$route.query.shopid)
			sessionStorage.setItem("loginPage", "/merchantslogin?shopid="+this.$route.query.shopid);
			sessionStorage.setItem("routes", JSON.stringify(ro));
		},
		mounted() {
			let _this = this;
			// this.axios.get("/api/shop/basic/config-index").then((res) => {
			// 	if (res.code == 200) {
			// 		sessionStorage.setItem("configIndex", JSON.stringify(res.data.config));
			// 		_this.configData = res.data;
			// 		if (res.data.config.shop_is_verify == 1) {
			// 			_this.showGeetest = true;
			// 			initGeetest4({
			// 					captchaId: res.data.other_config.geetest_id,
			// 					product: "float",
			// 					riskType: "ai",
			// 					nativeButton: {
			// 						width: "339px",
			// 						height: "40px",
			// 					},
			// 				},
			// 				function(captcha) {
			// 					// captcha为验证码实例
			// 					captcha.appendTo("#captcha"); // 调用appendTo将验证码插入到页的某一个元素中，这个元素用户可以自定义
			// 					captcha.onSuccess(function() {
			// 						var result = captcha.getValidate();
			// 						_this.codePost.captcha_output = result.captcha_output;
			// 						_this.codePost.lot_number = result.lot_number;
			// 						_this.codePost.pass_token = result.pass_token;
			// 						_this.codePost.gen_time = result.gen_time;
			// 					});
			// 				}
			// 			);
			// 			initGeetest4({
			// 					captchaId: res.data.other_config.geetest_id,
			// 					product: "float",
			// 					riskType: "ai",
			// 					nativeButton: {
			// 						width: "339px",
			// 						height: "40px",
			// 					},
			// 				},
			// 				function(captcha) {
			// 					// captcha为验证码实例
			// 					captcha.appendTo("#captcha1"); // 调用appendTo将验证码插入到页的某一个元素中，这个元素用户可以自定义
			// 					captcha.onSuccess(function() {
			// 						var result = captcha.getValidate();
			// 						_this.codePost.captcha_output = result.captcha_output;
			// 						_this.codePost.lot_number = result.lot_number;
			// 						_this.codePost.pass_token = result.pass_token;
			// 						_this.codePost.gen_time = result.gen_time;
			// 					});
			// 				}
			// 			);
			// 		}
			// 	} else {
			// 		eltips(res.msg, "error");
			// 	}
			// });
		},
		methods: {
			//获取权限菜单
			getmeuns() {
				resetRouter();
				this.$store.commit("routestatus", 0);
				sessionStorage.removeItem("routestext");
				sessionStorage.removeItem("routes");
				sessionStorage.setItem("routes", JSON.stringify(ro));
				this.$router.replace({
					path: "/weishop/merchants/overview",
				});
			},
			sureLogin() {
				let _this = this;
				if (_this.loginLoading) {
					return false;
				}
				_this.loginLoading = true;
				let _url = "/api/weishop/merchant/login/index";
				sessionStorage.removeItem("routestext");
				sessionStorage.removeItem("routesOld");
				sessionStorage.removeItem("pluginroute");
				sessionStorage.removeItem("pluginid");
				sessionStorage.removeItem("routes");
				sessionStorage.removeItem("token");
				// sessionStorage.removeItem("shopid");
				sessionStorage.removeItem("storeid");
				// sessionStorage.removeItem("guardName")
				if (this.type == "code") {
					_url = "/api/weishop/merchant/login/mobile-login";
				}
				_this.codePost.sms_code = _this.codePost.code
				_this.codePost.account = _this.codePost.mobile
				_this.axios.post(_url, _this.codePost).then((res) => {
					if (res.code == 200) {
						eltips(res.msg, "success");
						sessionStorage.setItem("token", res.data.token);
						sessionStorage.removeItem("role_id");
						sessionStorage.removeItem("pluginroute");
						sessionStorage.removeItem("pluginid");
						sessionStorage.setItem('guardName', 'weishop_merchant_user')
						// this.getuserinfo()
						sessionStorage.setItem("userinfo", JSON.stringify(res.data.user));
						sessionStorage.setItem(
							"shopid",
							JSON.stringify(res.data.user.shop_id)
						);
						sessionStorage.setItem(
							"storeid",
							JSON.stringify(res.data.user.store_id)
						);
						sessionStorage.setItem("role_id", JSON.stringify(res.data.user.id));
						this.getmeuns();
					} else {
						eltips(res.msg, "error");
					}
					setTimeout(function() {
						_this.loginLoading = false;
					}, 1000);
				});
			},

			extractFirstData(tree) {
				if (tree.children && tree.children.length > 0) {
					return this.extractFirstData(tree.children[0]);
				}
				return tree;
			},
			pageChangeFun(e) {
				this.page = e;
			},
			getCodeFun() {
				let _this = this;
				if (this.codePost.mobile.length < 0) {
					eltips("手机号不能为空", "error");
					return;
				}
				if (this.codeTime != 60) {
					console.log("时间不足", this.codeTime);
					return;
				}
				_this.axios
					.post("/api/weishop/merchant/login/sendSms", {
						account: this.codePost.mobile,
						type: 0,
					})
					.then((res) => {
						if (res.code == 200) {
							_this.codeInter = setInterval(function() {
								_this.codeTime--;
								_this.codetitle = _this.codeTime + "S";
								if (_this.codeTime <= 1) {
									clearInterval(_this.codeInter);
									_this.codeInter = null;
									_this.codetitle = "获取验证码";
									_this.codeTime = 60;
								}
							}, 1000);
						} else {
							_this.codetitle = "发送验证码";
							_this.codeTime = 60;
							_this.codeInter = null;
							eltips(res.msg, "error");
						}
					});
			},
			tabChange(e) {
				console.log("eeee",e)
				this.type = e;
				// this.$nextTick(() => {
				// 	this.$refs.codeForm.clearValidate();
				// 	this.$refs.pwdForm.clearValidate();
				// })
			},
			mobileNumFun(e) {
				this.mobileNum = e;
				console.log(e);
			},
			traverseTree(treeList) {
				let _this = this;
				const keyMap = {
					id: "id", // 将 "id" 修改为 "nodeId"
					menuName: "name", // 将 "id" 修改为 "nodeId"
					uri: "component", // 将 "name" 修改为 "label"
					url: "path", // 将 "name" 修改为 "label"
					// children: '_child', // 将 "name" 修改为 "label"
					icon_url: "icon", // 将 "name" 修改为 "label"
					layout: "layout", // 将 "name" 修改为 "label"
					router_name: "router_name", // 将 "name" 修改为 "label"
					vue_name: "vue_name", // 将 "name" 修改为 "label"
					app_level: "app_level", // 将 "name" 修改为 "label"
					plugin: "plugin", // 将 "name" 修改为 "label"
					is_plugin: "is_plugin", // 将 "name" 修改为 "label"
				};
				return treeList.map((item) => ({
					...Object.keys(keyMap).reduce((acc, oldKey) => {
						const newKey = keyMap[oldKey];
						acc[newKey] = item[oldKey];
						delete item[oldKey];
						return acc;
					}, {}),
					_child: item.children ? _this.traverseTree(item.children) : [],
				}));
			},
		},
	};
</script>

<style lang="scss" scoped>
	.imgC {
		position: absolute;
		top: 0;
		right: 0;
		width: 101px;
		height: 101px;
		display: block;
		// background: url("@/admin/login/img/qrcode2.png") no-repeat 50%;
		background-size: 90px;
		cursor: pointer;
		z-index: 9;
	}

	.imgC:hover {
		width: 101px;
		height: 101px;
		// background-image: url("@/admin/login/img/qrcode_hover2.png") !important;
		transition: all 0.4s ease;
		background-size: 90px;
	}

	.imgT {
		position: absolute;
		right: 0;
		top: 0;
		width: 90px;
		height: 90px;
		border-radius: 0 10px 0 0;
		border-color: #f2f7ff #f2f7ff #fff #fff;
		border-style: solid;
		border-width: 50px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}

	.title {
		margin-top: 12px;

		span {
			font-size: 20px;
			color: #b6babf;
			cursor: pointer;
			font-weight: 400;
			-webkit-transition: color 0.2s linear;
			transition: color 0.2s linear;
		}

		&_active {
			color: #1e2226 !important;
			font-weight: 600 !important;
		}

		strong {
			width: 1px;
			height: 16px;
			background: #e1e2e6;
			margin: 0 12px;
			display: inline-block;
		}
	}

	.loginForm {
		margin-top: 30px;
	}

	.loginForm ::v-deep .el-form-item__label {
		padding-bottom: 0;
		font-weight: 600;
		color: #1f2026;
		font-size: 14px;
	}

	.page_to {
		display: flex;
		align-items: center;
		justify-content: space-between;

		a {
			color: #8a9099;
		}
	}

	.agrement {
		display: flex;
		color: #8a9099;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		margin-top: 10px;
		height: 19px;
		line-height: 20px;
		font-size: 12px;

		a {
			color: #1e2226;
		}
	}

	.mobileNumer {
		&_line {
			height: 40px;
			line-height: 40px;
			border-right: 1px solid #ededed;
			padding-right: 8px;
			padding-left: 10px;
		}
	}

	.mobileNumer ::v-deep .el-input-group__prepend {
		background-color: #fff;
		border-right: 0 !important;
	}

	.mobileNumer ::v-deep .el-input__inner {
		padding-left: 80px;
	}

	.getcode ::v-deep .el-input__inner {
		padding-right: 90px;
	}

	.getcode_num {
		width: 80px;
		height: 40px;
		line-height: 40px;
		padding-right: 10px;
		text-align: center;
		cursor: pointer;
		color: #b6babf;
		font-size: 14px;
	}

	.imgCQ {
		position: absolute;
		top: 0;
		right: 0;
		width: 101px;
		height: 101px;
		display: block;
		// background: url("@/admin/login/img/account_2.png") no-repeat 50%;
		background-size: 90px;
		cursor: pointer;
		z-index: 9;
	}

	.imgCQ:hover {
		width: 101px;
		height: 101px;
		// background-image: url("@/admin/login/img/account_hover2.png") !important;
		transition: all 0.4s ease;
		background-size: 90px;
	}

	.imgTQ {
		position: absolute;
		right: 0;
		top: 0;
		width: 90px;
		height: 90px;
		border-radius: 0 10px 0 0;
		border-color: #f2f7ff #f2f7ff #fff #fff;
		border-style: solid;
		border-width: 50px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}

	.qr_box {
		width: 240px;
		height: 284px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		border: 1px solid #f0f2f5;
		border-radius: 6px;
		padding: 12px;
		margin: 35px auto 28px auto;
		position: relative;
		-webkit-transition: margin 0.5s ease;
		transition: margin 0.5s ease;

		&_img {
			width: 216px;
			height: 216px;
			border-radius: 6px;
			background-color: #8a9099;
		}

		&_flex {
			display: flex;
			align-items: center;
			justify-content: center;
			color: #8a9099;
			font-size: 14px;
			margin-top: 12px;

			img {
				width: 20px;
				height: 20px;
				margin-right: 4px;
			}
		}
	}
</style>